import { render, staticRenderFns } from "./settlement_record.vue?vue&type=template&id=fcf95a4c&scoped=true"
import script from "./settlement_record.vue?vue&type=script&lang=js"
export * from "./settlement_record.vue?vue&type=script&lang=js"
import style0 from "./settlement_record.vue?vue&type=style&index=0&id=fcf95a4c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf95a4c",
  null
  
)

export default component.exports